import { createSelector } from 'reselect';
import { assign, flatMap, get, map, some } from 'lodash/fp';

import teamPositionsSelector from './teamPositionsSelector';
import salaryRemainingSelector from './salaryRemainingSelector';
import playerPositionsSelector from './playerPositionsSelector';

function getTeams(
  teams,
  positions,
  playerPositions,
  salaryRemaining,
  teamQuota,
  playerQuota,
  shareQuota
) {
  const selections = flatMap('selections', positions);
  const playerSelections = flatMap('selections', playerPositions);
  const allSelected = shareQuota
    ? playerSelections.length + selections.length === playerQuota
    : selections.length === teamQuota;

  return flatMap(
    team =>
      map(
        pos =>
          assign(
            some({ id: team.id }, selections)
              ? {
                  disabled: false,
                  selected: true,
                  selectedPosition: pos.id
                }
              : {
                  disabled: allSelected || pos.filled,
                  selected: false
                },
            team
          ),
        positions
      ),
    teams
  );
}

const teamsSelector = createSelector(
  get('challenge.teams'),
  teamPositionsSelector,
  playerPositionsSelector,
  salaryRemainingSelector,
  get('challenge.teamQuota'),
  get('challenge.playerQuota'),
  get('challenge.shareQuota'),
  getTeams
);

export default teamsSelector;
